import { resolveCoordinatesNetwork } from './map-coords.js';

let processing = false;
/** @type {Array<{ job: object, priority: number, resolve: Function }>} */
const queue = [];

function jobKey(job) {
  return `${job.instanceId ?? 'x'}:${job.entityType ?? 'x'}:${job.entityId ?? job.id}`;
}

const inFlight = new Map();

/**
 * @param {object} job
 * @param {number} [priority] higher runs first
 */
export function enqueueGeocode(job, priority = 0) {
  const key = jobKey(job);
  if (inFlight.has(key)) return inFlight.get(key);

  const promise = new Promise((resolve) => {
    queue.push({ job, priority, resolve });
    queue.sort((a, b) => b.priority - a.priority);
    drainQueue();
  });

  inFlight.set(key, promise);
  promise.finally(() => inFlight.delete(key));
  return promise;
}

async function drainQueue() {
  if (processing) return;
  processing = true;

  while (queue.length) {
    const item = queue.shift();
    try {
      const coords = await resolveCoordinatesNetwork(item.job.entity, {
        country: item.job.country ?? '',
        instanceId: item.job.instanceId,
        entityType: item.job.entityType,
        entityId: item.job.entityId,
        entityUpdatedAt: item.job.entityUpdatedAt,
      });
      item.resolve(coords);
    } catch {
      item.resolve(null);
    }
  }

  processing = false;
}

export function clearGeocodeQueue() {
  queue.length = 0;
  inFlight.clear();
}
